<template lang="pug">
  .content
    .content__block.content-placement(
      v-if="placement && placement.length > 0"
    )
      .content-placement__container
        .content-placement__item(
          v-if="houses.length > 0"
        )
          .content-placement__img
            img(
            src="/../img/temp/houses.png"
            )
            .content-placement__subgroup(
              v-for="(house, houseIndex) in houses"
            )
              h3.camp-content__subtitle {{house.name.text}}
              ul
                li(
                  v-for="item in housesItems[houseIndex]"
                )
                  span.camp-content__text {{item}}
        .content-placement__item(
          v-for="item in otherItems"
        )
          .content-placement__img
            img(
            :src="setImgSrc(item.type)"
            )
          h3.camp-content__subtitle {{item.name}}
          ul
            li(
            v-for="extraItem in item.extra.split(';')"
            )
              span.camp-content__text {{extraItem}}

    .content__block(
    v-else
    )
      p.text Нет информации
</template>

<script>

export default {
  name: "CampPlacement",
  props: {
    placement: {
      type: Array,
      default: () => ({})
    }
  },
  computed: {
    // placement() {
    //   if (this.campData && this.campData.placement) {
    //     return this.campData.placement;
    //   }
    //   return null;
    // },
    houses() {
      if (this.placement) {
        return this.placement.filter(item => item.type === "корпус");
      }
      return null;
    },
    otherItems() {
      if (this.placement) {
        return this.placement.filter(item => {
          return item.type !== "корпус" && (typeof (item.visible) === "undefined" || item.visible === true);
        });
      }
      return null;
    },
    housesItems() {
      if (this.houses && this.houses.length > 0) {
        const arr = this.houses.map(item => {
          return item.extra.split(";");
        });
        return arr;
      }
      return null;
    }
  },
  methods: {
    setImgSrc(type) {
      if (type === "питание") {
        return "/../img/temp/cutlery.png";
      }
      if (type === "гигиена") {
        return "/../img/temp/bath.png";
      }
      if (type === "творчество") {
        return "/../img/temp/stage.png";
      }
      if (type === "спорт") {
        return "/../img/temp/soccer-ball.png";
      }
      if (type === "лечение") {
        return "/../img/temp/treatment.png";
      }
      return "/../img/temp/houses.png";
    }
  }
};
</script>
